export enum FeatureFlags {
  configBankDisruptionMessage = 'configure-bank-disruption-message',
  payoutsPage = 'payouts-page', // Active. On for specific app_tokens
  paymentsPage = 'payments-page', // Stale. Serving Off for KSA
  rolloutMfa = 'rollout-mfa', // Stale. Serving On
  rolloutAccountTypes = 'rollout-account-types', // Stale. Serving On for KSA
  rolloutHyperlinkBankSelection = 'rollout-hyperlink-bank-selection', // Stale. Serving On
  rolloutSkipOtpLoginSetup = 'rollout-skip-otp-login-setup',
  rolloutHyperlinkLinksdkv2 = 'rollout-hyperlink-linksdkv2',
  rolloutOwnerRole = 'rollout-add-owner-role',
  rolloutPaymentsDownload2k = 'rollout-payments-download-2k',
  rolloutUaeConsentExplanation = 'rollout-uae-consent-explanation',
  rolloutRefunds = 'rollout-refunds',
  rolloutPayoutDashboardInitiation = 'rollout-payouts-dashboard-initiation',
  rolloutPayoutSelfOnboarding = 'rollout-payouts-self-onboarding',
  rolloutPayoutsNewAuthorizeFlow = 'rollout-payouts-new-authorize-flow', // skip LinkSDK for payout authorization
  killSignInPage = 'kill-sign-in-page',
  rolloutLoginOidc = 'rollout-login-oidc',
  rolloutRegisterOidc = 'rollout-register-oidc',
  allowReconciliationPage = 'allow-reconciliation-page',
  rolloutBulkPayoutsInitiation = 'rollout-bulk-payouts-initiation',
  rolloutDashboardV2 = 'rollout-dashboard-v2',
  rolloutEnbdSmeDirectConnection = 'rollout-enbd-sme-direct-connection',
  rolloutRedirectUaeToV2 = 'rollout-redirect-uae-to-v2', // UAE only. Redirects v1 (dev portal) to v2 (dashboard) when On
  rolloutRedirectKsaToV2 = 'rollout-redirect-ksa-to-v2', // KSA only. Redirects v1 (dev portal) to v2 (dashboard) when On
}

export enum FeatureFlagsAttributes {
  country = 'country',
  appToken = 'app_token',
  customerId = 'customer_id',
  accessLevel = 'accessLevel',
  organizationId = 'organization_id',
  email = 'email',
  environmentName = 'environmentName',
}
